import { Injectable } from '@angular/core';
import { CanActivate, RouterStateSnapshot, ActivatedRouteSnapshot, Router } from '@angular/router';
import { StoreQuerierService } from '../../services/store-querier.service';

@Injectable({
    providedIn: 'root'
})
export class SettingsGuard implements CanActivate {
    constructor(
        private _router: Router,
        private _storeQuerier: StoreQuerierService,
    ) { }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        const currentUser = this._storeQuerier.getCurrentUser();
        if (!currentUser.credential.admin) {
            this._router.navigate(['settings/data']);
            return false;
        }
        return true;
    }
}
